module.exports = __webpack_public_path__ + "static/img/1366_phase_function_Paper_PointsHejduk_Prediction.aaadf8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1366_phase_function_Paper_PointsHejduk_Prediction.png
// module id = j5OF
// module chunks = 0